<script setup lang="ts">
	import { onBeforeUnmount, ref } from 'vue'
	import { useRouter } from 'vue-router'

	// Barra de progreso global de navegación (estilo GitHub/YouTube). Trickle:
	// avanza rápido al inicio y se frena cerca del 90% hasta que la ruta resuelve
	// (incluye la descarga del chunk lazy de la página). Montada una vez en App.vue.

	const progress = ref(0)
	const visible = ref(false)
	const fading = ref(false)

	let trickleTimer: number | null = null
	let hideTimer: number | null = null

	function clearTimers() {
		if (trickleTimer !== null) {
			window.clearInterval(trickleTimer)
			trickleTimer = null
		}
		if (hideTimer !== null) {
			window.clearTimeout(hideTimer)
			hideTimer = null
		}
	}

	function start() {
		clearTimers()
		fading.value = false
		visible.value = true
		progress.value = 8

		trickleTimer = window.setInterval(() => {
			const remaining = 90 - progress.value
			if (remaining <= 0) return
			progress.value += Math.max(0.4, remaining * 0.06)
		}, 180)
	}

	function finish() {
		if (!visible.value) return
		clearTimers()
		progress.value = 100
		fading.value = true

		hideTimer = window.setTimeout(() => {
			visible.value = false
			fading.value = false
			progress.value = 0
		}, 400)
	}

	const router = useRouter()

	const removeBefore = router.beforeEach((to, from) => {
		// Solo navegación de página; cambios de query (filtros, deep links en la
		// misma vista) no muestran la barra.
		if (to.path !== from.path) start()
	})
	const removeAfter = router.afterEach(() => finish())
	const removeError = router.onError(() => finish())

	onBeforeUnmount(() => {
		removeBefore()
		removeAfter()
		removeError()
		clearTimers()
	})
</script>

<template>
	<div
		v-if="visible"
		class="fixed top-0 left-0 right-0 z-[9999] h-[3px] pointer-events-none transition-opacity duration-300"
		:class="fading ? 'opacity-0' : 'opacity-100'"
	>
		<div
			class="h-full bg-[#021F58] transition-[width] duration-200 ease-out relative"
			:style="{ width: `${progress}%` }"
		>
			<!-- Punta con brillo, como la barra de YouTube -->
			<div
				class="absolute right-0 top-0 h-full w-24 bg-gradient-to-r from-transparent to-[#3987C5]"
			/>
		</div>
	</div>
</template>
